import http, { url } from '../../http'

const API_URL = "program_prevention_control"

class TrainingProgramAPI {

  async save(program) {
    const response = await http(`${API_URL}/save`, 'POST', program)
    return response
  }

  async getAll(companyID, page, search, year) {
    const y = year ? `&year=${year}` : ''
    const response = await http(`${API_URL}/company/${companyID}?page=${page}&search=${search}${y}`, 'POST')
    return response || null
  }

  async get(programID) {
    const response = await http(`${API_URL}/${programID}`)
    return response || null
  }
 
  async update(id, program) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', program)
    return response
  }
   
  async deletePromocion(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  // Actualiza solo el estado de ejecución (Pendiente|Ejecutado) de una capacitación.
  async updateStatus(id, status) {
    const response = await http(`${API_URL}/${id}/status`, 'PUT', { status })
    return response
  }

  // ── Plan de Capacitación Anual branded (cronograma por empresa + año, firma del encargado) ──
  planPdfUrl(companyId, year) {
    return url(`${API_URL}/plan-anual/${companyId}/${year}/pdf`)
  }

  async planSign(companyId, year, payload) {
    return await http(`${API_URL}/plan-anual/${companyId}/${year}/sign`, 'POST', payload)
  }

  async planStatus(companyId, year) {
    return await http(`${API_URL}/plan-anual/${companyId}/${year}/status`, 'GET')
  }
}

export default new TrainingProgramAPI()